<template>
  <div>
    <b-modal size="xl" id="how-to-modal" :title="title" hide-footer>
      <b-card no-body>
        <div style="padding:45.47% 0 0 0;position:relative;"><iframe :src="vimeo" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" :title="title"></iframe></div>
      </b-card>
    </b-modal>
  </div>
</template>

<script src="https://player.vimeo.com/api/player.js"></script>
<script>
export default {
  props: {
    source: null,
    video_title: null
  },
  computed: {
    title() {
      return this.video_title ? this.video_title : 'How To Video';
    },
    vimeo() {
      return 'https://player.vimeo.com/video/' + this.source + '?h=0ce28abadc&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479';
    }
  }
};
</script>